export { MyAtlassianRedirect } from './MyAtlassianRedirect';
